import { appKey } from './appStorage';

const KEY = appKey('inventory.warehouseId');

// Muistettu varasto, jos se on yhä olemassa; muuten ainoa varasto. Useasta varastosta ei arvata.
export function defaultWarehouseId(warehouses) {
  let remembered = null;
  try {
    remembered = Number(localStorage.getItem(KEY));
  } catch (e) {
    // localStorage ei käytettävissä
  }
  if (warehouses.some(w => w.id === remembered)) return remembered;
  return warehouses.length === 1 ? warehouses[0].id : null;
}

export function rememberWarehouseId(id) {
  try {
    localStorage.setItem(KEY, String(id));
  } catch (e) {
    // localStorage ei käytettävissä
  }
}
